/* Shared guidance for product, bundle and embedded upsell selection controls. */
(function () {
  if (window.RoydedSelection) return;
  var active = null, timer = null;
  function clear() {
    if (active) active.classList.remove('rd-selection-needed');
    active = null;
    window.clearTimeout(timer);
  }
  function prompt(target, control) {
    if (!target) return;
    clear();
    control = control || target.querySelector('button:not([disabled])');
    if (control) control.focus({ preventScroll: true });
    target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
    void target.offsetWidth;
    target.classList.add('rd-selection-needed');
    active = target;
    timer = window.setTimeout(clear, 2400);
  }
  document.addEventListener('click', function (event) {
    if (active && active.contains(event.target) && event.target.closest('button')) clear();
  }, true);
  window.RoydedSelection = { prompt: prompt };
})();
